import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../state'

import * as agentTab from './agent-tab'
import * as sharedTab from './shared-tab'

/** Platform Admin page for managing documents used by agent knowledge bases. */
@ngCore.Component({
  imports: [
    agentTab.Component,
    ds.layout.page.Component,
    ds.layout.page.child.header.Component,
    ds.loader.Component,
    ds.overlay.confirmation.Component,
    ds.tabs.floatingHorizontal.Component,
    ds.tabs.tab.Directive,
    sharedTab.Component,
  ],
  selector: 'atn-admin-knowledge-bases-page',
  standalone: true,
  templateUrl: './component.html',
})
export class Component {
  /** Workspace values dispatched by the document tabs. */
  public readonly selectionModes =
    state.admin.agentKnowledgeBases.models.Selection.Mode

  /** Entity collection displayed by the knowledge-base documents table. */
  public readonly filesEc = ngCore.inject(
    state.admin.agentKnowledgeBases.Collection,
  )
}
